diy.angular.registerDirective('diyfmitems', ['$timeout', '$q', '$http', 'diyfmsectionsdata', 'diyfmconfig', 'diyfmselectiondata', 'diyfilename', 'diyl10n', 'diyfiledownload', 'diyanimationframe', 'diyfmmessages', 'diyfmsourcestorage', 'diyglobalevents',
function($timeout, $q, $http, diyfmsectionsdata, diyfmconfig, diyfmselectiondata, diyfilename, diyl10n, diyfiledownload, diyanimationframe, diyfmmessages, diyfmsourcestorage, diyglobalevents) {
    var $ = jQuery;
    return {
        template: '\
            <div class="fm-item-menu" data-diyfmmenu="" ng-model="menuConfig"></div>\
            <div class="fm-items-scroll"\
                ng-class="{\
                    \'fm-allow-insertions\': allowInsertions,\
                    \'fm-no-actions\': itemActions.length === 0\
                }"\
            >\
                <div class="fm-no-items" ng-show="items.length == 0 && !shouldShowUpsell()"><div><small></small><span>' + diyl10n('filemanager.messages.noitems') + '</span></div></div>\
                <div class="fm-items-wrapper">\
                    <div ng-show="shouldShowUpsell()" ng-bind-html="getUpsellContents()"></div>\
                    <div diyfmpreview></div>\
                    <div class="fm-items-rendered">\
                        <div class="fm-thumb-wrap" \
                            ng-class="{\'fm-thumb-previewed\': item === preview.item}"\
                            diyfmthumbnail="" \
                            ng-repeat="item in items" \
                        >\
                    </div>\
                </div>\
            </div>\
        ',
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {

            scope.$watch('sections.getCurrentSubsection().getSearch()', function(newSearch, oldSearch){
                var content;
                if (newSearch !== '') {
                    content = diyl10n('filemanager.messages.noitemsfound');
                } else {
                    content = diyl10n('filemanager.messages.noitems').format({uploadButtonLabel: diyl10n('filemanager.upload.button')});
                }
                jQuery('.fm-no-items').find('span').html(content);
            });

            scope.shouldShowUpsell = function() {
                var currentSource = scope.sections.getCurrentSubsection().getSource();
                if (typeof currentSource.shouldShowUpsell === 'function') {
                    return currentSource.shouldShowUpsell();
                }
            };
            
            scope.getUpsellContents = function() {
                var currentSource = scope.sections.getCurrentSubsection().getSource();
                if (typeof currentSource.getUpsellContents === 'function') {
                    return currentSource.getUpsellContents();
                }
            };

            var 
                $elem = $(elem),
                $itemsS = $elem.find('.fm-items-scroll'),
                $itemsW = $elem.find('.fm-items-wrapper'),
                $itemsR = $elem.find('.fm-items-rendered'),
                itemsRTop,
                itemsRHeight,
                BUFFER_SCREENS = 1, // number of screens used as buffers (on top and on bottom)
                // just an estimation, exact recalculation will be on initialLoad
                THUMB_HEIGHT = 100,
                THUMBS_PER_ROW = 4,
                screenHeight = $elem.outerHeight(),
                previewHeight = screenHeight * 0.8,
                previewTop,
                // XXX seems that $elem.find('[diyfmpreview]') doesn't work
                previewEl = $elem.find('[diyfmpreview]'),
                previewPosParent,
                ignoreScrollEvent = false,
                uploadArgsAfterLoadInitial,
                renderedOffset,
                renderedLimit,
                scrollRetrievePromise
            ;
            
            $timeout(function(){
                // XXX refresh heights after rendering
                screenHeight = $elem.outerHeight();
                previewHeight = screenHeight * 0.8;
                previewEl.height(previewHeight);
            });
            previewPosParent = previewEl.parent()
            while (previewPosParent.css('position') === 'static') {
                previewPosParent = previewPosParent.parent();
            }
            
            var getThumbsPerScreen = function() {
                return Math.ceil(screenHeight / THUMB_HEIGHT) * THUMBS_PER_ROW;
            };
            
            var itemsScrollTop = function(scrollTop, forceReload) {
                if (scope.preview.item) {
                    // if there is a preview, adjust scrollTop
                    if (scrollTop > previewTop) {
                        if (scrollTop < previewTop + previewHeight) {
                            scrollTop = previewTop;
                        } else {
                            scrollTop = scrollTop - previewHeight;
                        }
                    }
                    
                }
                var 
                    reqOffset = Math.floor(scrollTop / THUMB_HEIGHT) * THUMBS_PER_ROW,
                    thumbsPerScreen = getThumbsPerScreen()
                ;
                forceReload = forceReload || false;
                
                if (!forceReload &&
                    (renderedOffset === 0 || reqOffset > renderedOffset + thumbsPerScreen/2)
                    && reqOffset + thumbsPerScreen < renderedOffset + renderedLimit - thumbsPerScreen/2
                ) {
                    // we still have all visible space filled with a half of screen buffer
                    return;
                }
                
                var 
                    offset = Math.max(0, reqOffset - BUFFER_SCREENS * thumbsPerScreen),
                    limit = thumbsPerScreen * (BUFFER_SCREENS * 2 + 1)
                ;
                
                scrollRetrievePromise && scrollRetrievePromise.reject();
                
                scrollRetrievePromise = scope.sections.getCurrentSubsection()
                    .retrieveItems(offset, limit)
                    .then(function(items){
                        scope.items = items;
                        // The commented code below is a nice try for optimisation
                        // but the behavior is weird because images are not instantly
                        // changed
                        /*
                        if (scope.items.length === items.length) {
                            console.log('setResources');
                            for(var i = 0; i < items.length; i ++) {
                                items[i].getResource().thumb = false;
                                scope.items[i].setResource(items[i].getResource());
                            }
                        } else {
                            console.log('setItems');
                            scope.items = items;
                        }
                        */
                        renderedOffset = offset;
                        renderedLimit = limit;
                        
                        // let it render (do a timeout with 0)
                        $timeout(function(){
                            itemsRHeight = $itemsR.height();
                            scope.preview.item && restorePreview();
                        }, 0);
                        scrollRetrievePromise = undefined;
                    });
                
                itemsRTop = offset / THUMBS_PER_ROW * THUMB_HEIGHT;
                
                if (scope.preview.item && itemsRTop > previewTop) {
                    itemsRTop = itemsRTop + previewHeight;
                }
                
                $itemsR.css('top', itemsRTop + 'px');
            };
            
            var loadInitial = function() {
                ignoreScrollEvent = true;
                var subsection = scope.sections.getCurrentSubsection();
                
                // transfer to a local variable in case
                // a subsequent loadInitial would occur
                var uploadArgs = uploadArgsAfterLoadInitial;
                uploadArgsAfterLoadInitial = undefined;
                
                $itemsS.scrollTop(0);
                itemsRTop = 0;
                $itemsR.css('top', itemsRTop + 'px');
                $itemsW.css('height', '');
                scope.items = undefined; // must be set to undefined so the "no items info won't be displayed!

                $elem.loadingBox({useOverlay: true}).show();
                
                var offset = 0, limit = getThumbsPerScreen() * (BUFFER_SCREENS + 1);
                
                subsection.retrieveItems(offset, limit)
                    .then(function(items){
                        scope.items = items;
                        renderedOffset = offset;
                        renderedLimit = limit;
                        
                        // let it render (do a timeout with 0)
                        $timeout(function(){
                            var 
                                thumbs = $itemsR.find('.fm-thumb-wrap'),
                                offsTop, iOffsTop
                            ;
                            if (thumbs.length > 0) {
                                offsTop = thumbs.eq(0).offset().top;
                                for (var i = 1; i < thumbs.length; i++) {
                                    iOffsTop = thumbs.eq(i).offset().top;
                                    if (iOffsTop > offsTop) {
                                        THUMB_HEIGHT = iOffsTop - offsTop;
                                        THUMBS_PER_ROW = i;
                                        refreshItemsWrapHeight();
                                        break;
                                    }
                                }
                            }
                            itemsRHeight = $itemsR.height();
                            
                            $elem.loadingBox().hide();
                            diyglobalevents.trigger('diy-editor-filemanager-itemsretrieved', {});
                            ignoreScrollEvent = false;
                        }, 0);  
                        if (uploadArgs) {
                            doUploadFiles.apply(this, uploadArgs);
                            itemsScrollTop(0, true);
                        }
                        
                        if (subsection.getSearch() != '') {
                            scope.$emit('searchCompleted', {
                                subsection: subsection
                            });
                        }
                        
                    });
            };
            
            var refreshItemsWrapHeight = function() {
                var 
                    subsection = scope.sections.getCurrentSubsection(),
                    items = subsection.getItems();
                ;
                if (items) {
                    var height = Math.ceil(subsection.getItems().length / THUMBS_PER_ROW) * THUMB_HEIGHT;
                    if (scope.preview.item) {
                        height += previewEl.outerHeight();
                    }
                    $itemsW.height(height);
                }
            };
            
            var lengthUnwatch;
            
            
            scope.$watch('sections.getCurrentSubsection()', function(subsection){
                if (subsection !== undefined) {
                    lengthUnwatch && lengthUnwatch();
                    scope.itemActions = subsection.getItemActions();
                    loadInitial();
                    
                    lengthUnwatch = 
                        scope.$watch('sections.getCurrentSubsection().getItems().length', function(newLength, oldLength){
                            if (newLength !== oldLength && typeof newLength !== 'undefined') {
                                $itemsW.height(Math.ceil(newLength / THUMBS_PER_ROW) * THUMB_HEIGHT);
                                if (newLength < oldLength) {
                                    // some items deleted, reload items
                                    itemsScrollTop($itemsS.scrollTop(), true);
                                }
                                scope.preview.item && restorePreview();
                            }
                            // a special case when items cache is invalidated
                            // this can happen when a search is initiated/canceled
                            // or when an operation like folderDelete occured while we are
                            // on allimages folder
                            if (newLength === undefined && oldLength !== undefined) {
                                loadInitial();
                            }
                            var items = scope.sections.getCurrentSubsection().getItems();
                            if (scope.preview.item && 
                                (
                                    items === undefined || 
                                    items.indexOf(scope.preview.item) === -1
                                ) 
                            ) {
                                scope.hidePreview(false);
                            }
                        });
                }
            });
            
            var 
                onScrollPromise,
                loadingBoxShown
            ;
            
            $itemsS.bind('scroll', function(ev) {
                var sTop, itemsRBottom = itemsRTop + itemsRHeight;
                
                if (ignoreScrollEvent) return;
                
                if (!loadingBoxShown) {
                    sTop = $itemsS.scrollTop();
                    if (scope.preview.item
                        && itemsRTop + itemsRHeight >= previewTop
                        && itemsRTop < previewTop
                    ) {
                        itemsRBottom += previewHeight; 
                    }
                    if (
                        itemsRTop > sTop + screenHeight / 2
                        || itemsRBottom < sTop + screenHeight / 2
                    ) {
                        loadingBoxShown = true;
                        $elem.loadingBox({useOverlay: false}).show();
                    }
                }
                
                onScrollPromise && $timeout.cancel(onScrollPromise);
                onScrollPromise = $timeout(function(){
                    itemsScrollTop($itemsS.scrollTop());
                    $elem.loadingBox().hide();
                    loadingBoxShown = false;
                    onScrollPromise = undefined;
                }, 100);
            });
            
            scope.$on('uploadFiles.down', function(event, files, subsection, addToInsert, uploadSource){
                event.preventDefault(); // prevent handling in child scopes
                var currentSubsection = scope.sections.getCurrentSubsection();
                subsection = subsection || currentSubsection; 
                if (typeof subsection.uploadFiles !== 'function') {
                    subsection = scope.sections.getDefaultUploadSubsection();
                }
                
                if (currentSubsection !== subsection) {
                    uploadArgsAfterLoadInitial = arguments;
                    scope.sections.setCurrentSubsection(subsection);
                    scope.$digest();
                } else if (subsection.getSearch() !== '') {
                    uploadArgsAfterLoadInitial = arguments;
                    subsection.resetSearch();
                    scope.$digest();
                } else {
                    doUploadFiles.apply(this, arguments);
                    $itemsS.scrollTop(0);
                    itemsScrollTop(0, true);
                }
            });
            
            var doUploadFiles = function(event, files, subsection, addToInsert, uploadSource) {
                if (!diyfmconfig.isInManagementMode()) {
                    addToInsert = true;
                }
                var insertIndex = diyfmselectiondata.getInsertedItems().length;
                subsection.uploadFiles(files).then(function(response) {
                    // sometimes not all the notify promises are caught,
                    // however, we catch all at the end
                    if (Array.isArray(response.items) && response.items.length) {
                        response.items.forEach(function(item) {
                            if (!addToInsert) {
                                diyfmselectiondata.addItem(item, ['select'], 0);
                            }
                            if (addToInsert) {
                                diyfmselectiondata.addItem(item, ['insert'], insertIndex);
                            }
                        });
                        scope.$emit('uploadedFiles', {
                            uploadedItems: response.items,
                            source: uploadSource
                        });
                        if (addToInsert) {
                            scope.$emit('addToInsertion', {
                                items: response.items,
                                source: 'upload',
                                subsection: subsection
                            });
                        }
                    }
                    // error case is covered in success, as there may be mixed success + errors
                    if (Array.isArray(response.uploadErrors) && response.uploadErrors.length) {
                        diyfmmessages.handleUploadError(response.uploadErrors);
                    }
                }, angular.noop, function(notification) {
                    // add one by one, as they are done uploading
                    if (notification.item) {
                        if (!addToInsert) {
                            diyfmselectiondata.addItem(notification.item, ['select'], 0);
                        }
                        if (addToInsert) {
                            diyfmselectiondata.addItem(notification.item, ['insert'], insertIndex);
                        }
                    }
                });
            };
            
            scope.renameItem = function(item, newName) {
                var parsedName = diyfilename.parse(item.getName());
                parsedName.name = newName;
                item.setName(diyfilename.stringify(parsedName));
                item.$update();
                
                // XXX invalidate caches other folders containing this item
                // (the only case so far is allimagessubsection vs regular folder)
                // TODO use a global resource instance pool for syncronisation
                var 
                    currentSubsection = scope.sections.getCurrentSubsection(),
                    allImagesSubsection = diyfmsourcestorage.getAllImagesSubsection()
                ;
                
                if (currentSubsection === allImagesSubsection) {
                    var folder = diyfmsourcestorage.getSection().getFolderSectionById(item.getFolderId());
                    if (folder) {
                        folder.clearItemsCache();
                    }
                } else {
                    allImagesSubsection.clearItemsCache();
                }
            };
            
            scope.deleteItem = function(item) {
                diyfmmessages.showMessageItemsThumbs({
                    items: [item],
                    title: diyl10n('filemanager.items.menu.deleteconfirmation.message'),
                    ok: diyl10n('filemanager.sections.menu.delete'),
                    cancel: diyl10n('cancel')
                }).then(function() {
                    diyfmsectionsdata.getCurrentSubsection().deleteItems([item]);
                    scope.$emit('deleteFilesClicked', {
                        itemsCount: 1
                    });
                });
            };
            
            scope.openMenu = function(item, ev, itemScope) {
                var thumb = $(ev.target).closest('.fm-thumb');
                thumb.addClass('menu-opened');
                var menuTargetEl = $(ev.target).closest('button');
                scope.menuConfig = {
                    menuTargetEl: menuTargetEl,
                    getActions: function() {
                        return scope.itemActions;
                    },
                    menuClose: function() {
                        thumb.removeClass('menu-opened');
                    },
                    'delete': function() {
                        scope.deleteItem(item);
                    },
                    preview: function() {
                        scope.showPreview(item, true);
                    },
                    download: function() {
                        diyfiledownload(item.getFile());
                    }
                };
                if (diyfmconfig.shouldShowFileNames()) {
                    scope.menuConfig['rename'] = function() {
                        var parsedName = diyfilename.parse(item.getName());
                        itemScope.nameEditConfig.start(parsedName.name);
                    };
                }
                ev.stopPropagation();
            };
            
            scope.toggleInsert = function(item, source) {
                if (diyfmselectiondata.isItemInserted(item)) {
                    diyfmselectiondata.removeItem(item, ['insert']);
                } else {
                    diyfmselectiondata.addItem(item, ['insert']);
                    scope.$emit('addToInsertion', {
                        items: [item],
                        source: source,
                        subsection: diyfmsectionsdata.getCurrentSubsection()
                    });
                }
            };
            
            scope.preview = {};
            
            scope.hidePreview = function(withAnimation, scrollBackToImage) {
                scope.preview.item = undefined;
                
                hidePreview(withAnimation, scrollBackToImage).then(function(){
                    refreshItemsWrapHeight();
                });
            };
            
            scope.showPreview = function(item, withAnimation) {
                var shouldHideOldPreview = scope.preview.item !== undefined;
                scope.preview.item = item;
                
                // let it be rendered first
                $timeout(function(){
                    if (shouldHideOldPreview) {
                        hidePreview(withAnimation).then(function(){
                            showPreview(withAnimation).then(function(){
                                refreshItemsWrapHeight();
                            });
                        });
                    } else {
                        showPreview(withAnimation).then(function(){
                            refreshItemsWrapHeight();
                        });
                    }
                });
            };
            
            scope.$watch('preview.item', function(newPreviewItem, oldPreviewItem){
                scope.preview.prevItem = null;
                scope.preview.nextItem = null;
                
                if (newPreviewItem){
                    var 
                        subsection = scope.sections.getCurrentSubsection(),
                        items = subsection.getItems(),
                        previewIndex = items.indexOf(newPreviewItem)
                    ;
                    
                    if (previewIndex > -1) {
                        if (previewIndex > 0) {
                            scope.preview.prevItem = items[previewIndex - 1];
                        }
                        if (previewIndex + 1 < items.length) {
                            scope.preview.nextItem = items[previewIndex + 1];
                        }
                    }
                }
            });
            
            var hidePreview = function(withAnimation, scrollBackToImage) {
                var defer = $q.defer();
                
                if (itemsRTop > previewTop) {
                    itemsRTop = itemsRTop - previewHeight;
                    $itemsR.css('top', itemsRTop + 'px');
                    // moving scroll so that visible $itemsR (rendered element)
                    // remain at same position on the screen
                    ignoreScrollEvent = true;
                    $itemsS.scrollTop($itemsS.scrollTop() - previewHeight);
                    ignoreScrollEvent = false;
                }
                
                previewEl.hide();
                
                var prevMargins = $itemsR.find('.fm-thumb-spacing')
                    .removeClass('fm-thumb-spacing');
                
                // remove previously set margins
                if (prevMargins.length > 0) {
                    var 
                        adjustScroll = $itemsS.scrollTop() > previewTop,
                        previewVisible = ($itemsS.scrollTop() < previewTop + previewHeight) 
                                && (previewTop < $itemsS.scrollTop() + screenHeight)
                    ;
                    
                    if (adjustScroll || scrollBackToImage) {
                        var startScrollTop = $itemsS.scrollTop();
                    }
                    
                    var scrollAndRemoveMargins = function() {
                        prevMargins.css('margin-bottom', 0);
                        if (adjustScroll) {
                            $itemsS.scrollTop(startScrollTop - previewHeight);
                        } else if (scrollBackToImage) {
                            $itemsS.scrollTop(startScrollTop - previewHeight/2);
                        }
                    };
                    
                    if (withAnimation && previewVisible) {
                        ignoreScrollEvent = true;
                        
                        var 
                            startMargin = parseInt(prevMargins.css('margin-bottom'), 10)
                        ;
                        
                        diyanimationframe(250, function(progress){
                            var margin = Math.round(startMargin * (1 - progress));
                            prevMargins.css('margin-bottom', margin + 'px')
                            if (adjustScroll) {
                                $itemsS.scrollTop(startScrollTop - (startMargin - margin));
                            } else if (scrollBackToImage) {
                                $itemsS.scrollTop(startScrollTop - (startMargin - margin) / 2);
                            }
                        }, function(){
                            scrollAndRemoveMargins();
                            ignoreScrollEvent = false;
                            defer.resolve();
                        });                        
                    } else {
                        scrollAndRemoveMargins();
                        defer.resolve();
                    }
                } else {
                    defer.resolve();
                }
                
                return defer.promise;
            };
            
            var showPreview = function(withAnimation) {
                var defer = $q.defer();
                
                var lastInRow = getLastInRowAfterPreviewed();
                if (!lastInRow) {
                    return;
                }
                
                positionPreview(lastInRow);
                
                lastInRow.addClass('fm-thumb-spacing')
                    .css('margin-bottom', '0px');
                
                var
                    startScroll = $itemsS.scrollTop(),
                    finalScroll = previewTop - screenHeight * 0.05
                ;
                
                var doShowPreview = function() {
                    previewEl.show();
                    $itemsS.scrollTop(finalScroll);
                    itemsScrollTop(finalScroll);
                    lastInRow.css('margin-bottom', previewHeight + 'px');
                };
                
                if (withAnimation) {
                    ignoreScrollEvent = true;

                    diyanimationframe(250, function(progress) {
                        // manually add margins equal to the height of the preview
                        // class is added just for find it later on cleanup
                        lastInRow.css('margin-bottom', previewHeight * progress + 'px');
                        $itemsS.scrollTop(startScroll + (finalScroll - startScroll) * progress);
                    } , function() {
                        doShowPreview();
                        defer.resolve();
                        ignoreScrollEvent = false;
                    });
                } else {
                    doShowPreview();
                    defer.resolve();
                }
                
                return defer.promise;
            };
            
            var getLastInRowAfterPreviewed = function() {
                var previewedThumb = $itemsR.find('.fm-thumb-previewed');
                
                if (previewedThumb.length === 0) {
                    return;
                }
                
                var 
                    lastInRow = previewedThumb,
                    rowOffset = lastInRow.offset().top,
                    next = lastInRow.next(), nextOffset
                ;
                
                while(next.length > 0) {
                    nextOffset = next.offset().top;
                    if (nextOffset > rowOffset) {
                        break;
                    } else {
                        lastInRow = next;
                    }
                    next = lastInRow.next();
                }
                return lastInRow;
            };
            
            var positionPreview = function(lastInRow) {
                previewTop = lastInRow.offset().top - previewPosParent.offset().top 
                    + lastInRow.outerHeight();
                previewEl.css('top',  previewTop + 'px');
            };
            
            var restorePreview = function() {
                var prevMargins = $itemsR.find('.fm-thumb-spacing')
                    .removeClass('fm-thumb-spacing');
                
                prevMargins.css('margin-bottom', '');
                
                var lastInRow = getLastInRowAfterPreviewed();
                
                if (!lastInRow) {
                    return;
                }
                
                positionPreview(lastInRow);
                
                lastInRow.addClass('fm-thumb-spacing');
                
                // manually add margins equal to the height of the preview
                // class is added just for find it later on cleanup
                lastInRow.css('margin-bottom', previewHeight + 'px');
            };
            
            scope.allowInsertions = diyfmselectiondata.allowInsertions();
            
            // load drag images at beginning
            var dragSingle = new Image(), dragMultiple = new Image();
            dragSingle.src = jimdoData.cdnUrl + 's/diy/filemanager/images/drag-single.png';
            dragMultiple.src = jimdoData.cdnUrl + 's/diy/filemanager/images/drag-multiple.png';

            // TODO this is used for preloading images for IE, where drag and drop image is done with a hack, using background-images
            // TODO separate this into a service
            var $preloadEl = jQuery('<div class="fm-fallback-draggable-preload"></div>').css({
                position: 'absolute',
                top: 0,
                left: 0
            }).prependTo(jQuery(elem));
            setTimeout(function() {
                // we don't know when the images will load, so we take a lucky guess
                $preloadEl.remove();
            }, 5000)


            $elem.delegate('.fm-thumb', 'dragstart', function(ev) {
                if (diy.editor.uiPreference.isPointerModeTouch()) {
                    jQuery('.fm-items').addClass('fm-drag-feedback');
                    setTimeout(function() {
                        jQuery('.fm-items').removeClass('fm-drag-feedback');
                    }, 1000);
                }

                ev.originalEvent.dataTransfer.dropEffect = 'move';
                ev.originalEvent.dataTransfer.setData("Text", ""); // XXX Firefox hack, otherwise drag does not begin

                // if we start dragging from an unselected item, select it so it would be part of the selection that's moved
                var item = angular.element(this).scope().item;
                if (!diyfmselectiondata.isItemSelected(item)) {
                    // if we can't select it (for example if is during an upload, don't start dragging
                    if (!item.canSelect()) {
                        return false;
                    }
                    // select it
                    scope.$apply(function() {
                        diyfmselectiondata.addItem(item, ['select']);
                    });
                }

                // if we don't have any selected item, don't start dragging
                var selectedItems = diyfmselectiondata.getSelectedItems();
                if (selectedItems.length === 0) {
                    return false;
                }

                // set the drag image
                if ('function' === typeof ev.originalEvent.dataTransfer.setDragImage) {
                    var imageOffsetX = -10, imageOffsetY = -10;
                    if (diy.editor.uiPreference.isPointerModeTouch()) {
                        imageOffsetX = -40; 
                        imageOffsetY = -40;    
                    }
                    ev.originalEvent.dataTransfer.setDragImage(
                        selectedItems.length === 1 ? dragSingle : dragMultiple, 
                        imageOffsetX, imageOffsetY
                    );
                } else {
                    /* XXX IE 11 hack
                    IE does not implement the setDragImage method, so, we found a way to overcome this:
                    - set some classes on an element
                    - remove them immidiately (setTimeout 0)
                    - in this way, IE gets the chance to make a quick snapshot of the element that
                        we faked to look just like the drag icon
                    */
                    var $currentThumbEl = jQuery(this).addClass('fm-fallback-draggable').addClass(function() {
                        return 'fm-fallback-draggable-' + (selectedItems.length === 1 ? 'single' : 'multiple');
                    });
                    setTimeout(function() {
                        $currentThumbEl.removeClass('fm-fallback-draggable fm-fallback-draggable-single fm-fallback-draggable-multiple');
                    }, 0);
                }
            });
            
            var thumbClickHandlerTimeout, preventDoubleClick;

            // OPTIMIZATION: instead of binding a click event on each of the thumb
            // we better delegate it. When a click is triggered, an item's selection
            // is toggled
            $elem.delegate('.fm-thumb', 'click', function(ev) {
                var thumb = this;
                thumbClickHandlerTimeout = setTimeout(function(){
                    thumbClickHandler.call(thumb, ev);
                }, 100);
            });
            
            var thumbClickHandler = function(ev) {
                var itemScope = angular.element(this).scope(), item = itemScope.item;
                
                preventDoubleClick = false;

                if ($(ev.target).is('input')) {
                    return false;
                }
                
                if ($(ev.target).closest('button').hasClass('fm-thumb-menu')) {
                    // we don't want on double click on menu button 
                    // item to be added to insertion
                    // so we set prevention flag                      
                    preventDoubleClick = true;
                    scope.openMenu(itemScope.item, ev, itemScope);
                    scope.$digest();
                    return false;
                }

                if ($(ev.target).closest('button').hasClass('fm-thumb-preview')) {
                    // we don't want on double click on preview button 
                    // item to be added to insertion
                    // so we set prevention flag                    
                    preventDoubleClick = true;
                    scope.$apply(function(){
                        scope.showPreview(item, true);
                    });
                    return;
                }

                /* if item is marked for insertion */
                if (
                    $(ev.target).closest('button').hasClass('fm-thumb-add')
                    || !diyfmconfig.isInManagementMode()
                ) {
                    // we don't want on double click the insertion to be lost
                    // so we set prevention flag
                    preventDoubleClick = true;
                    scope.toggleInsert(item, 'thumbnail');
                    itemScope.$apply();
                    return false;
                }

                // if the item is selected
                if (diyfmselectiondata.isItemSelected(item)) {
                    // remove selection and insertion from the item
                    diyfmselectiondata.removeItem(item, ['select']);
                } else {
                    // if it's not inserted, insert it
                    diyfmselectiondata.addItem(item, ['select']);
                }
                itemScope.$apply();
            };
            
            $elem.delegate('.fm-thumb', 'dblclick', function(ev) {
                // because squence is click - click - dblclick
                // we need to cancel here second click
                thumbClickHandlerTimeout && clearTimeout(thumbClickHandlerTimeout);
                
                if (preventDoubleClick) {
                    return false;
                }
                
                if (!$(this).hasClass('fm-uploading')) {
                    var itemScope = angular.element(this).scope(), item = itemScope.item;
                    scope.toggleInsert(item, 'thumbnail-dblclick');
                    itemScope.$apply();
                    return false;
                }
            });
            
            // prevent scrolling on window when scrolling inside items
            // http://stackoverflow.com/questions/5802467/prevent-scrolling-of-parent-element
            $itemsS.bind('mousewheel', function(e, d)  {
                var t = $(this);
                if (d > 0 && t.scrollTop() === 0) {
                    e.preventDefault();
                }
                else {
                    if (d < 0 && (t.scrollTop() == t.get(0).scrollHeight - t.innerHeight())) {
                        e.preventDefault();
                    }
                }
            });
            
        }
    };
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmitems.js
 ** module id = 971
 ** module chunks = 0
 **/